<template>
  <li class="flex shadow-sm rounded-md overflow-hidden">
    <div
      class="flex-shrink-0 flex items-center justify-center w-16 bg-gray-600 text-white text-sm font-medium rounded-l-md"
    >
      <img
        v-if="project.cover"
        :src="project.cover"
        alt=""
        class="object-cover pointer-events-none w-full h-full"
      />
      <svg
        v-else
        class="w-5 h-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0
          012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2
          0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
    </div>
    <div
      class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
    >
      <div class="flex-1 px-4 py-2 text-sm truncate">
        <p class="text-gray-900 font-medium hover:text-gray-600">
          {{ project.name }}
        </p>
        <p v-if="client" class="text-gray-500">
          {{ client.name }}
        </p>
      </div>
      <div class="flex-shrink-0 pr-2">
        <button
          class="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          @click="remove"
        >
          <span class="sr-only">Remove current project</span>
          <svg
            class="w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    client() {
      if (!this.project?.client) {
        return null;
      }

      if (typeof this.project.client === 'object') {
        return this.project.client;
      }

      return this.$store.state.entities.accounts.byId[this.project.client] || null;
    },
  },
  methods: {
    remove() {
      this.$emit('remove');
    },
  },
};
</script>
